import { Controller } from "@hotwired/stimulus";
import Plyr from "plyr";

export default class extends Controller {
  static targets = ["player"];

  connect() {
    this.autoplay = this.element.classList.contains("is-autoplay");

    if (this.hasPlayerTarget) {
      this.initVideoPlayer();
    }

    // Closable
    if (this.element.classList.contains("is-closable")) {
      this.element.addEventListener("click", this.close);
    }
  }

  initVideoPlayer() {
    this.player = new Plyr(this.playerTarget, {
      autoplay: this.autoplay,
      clickToPlay: false,
      controls: ["play-large", "play", "progress", "mute", "fullscreen"],
      // debug: true,
      loop: { active: true },
      playsinline: true,
      youtube: { cc_load_policy: 0 },
      vimeo: { texttrack: false },
      // muted: true
    });
  }

  close(e) {
    if (e.target.type === "a" || e.target.type === "button" || e.target.closest(".plyr__controls"))
      return;
    window.history.back();
  }
}
